import { t } from "@lingui/core/macro"
import { Clock } from "lucide-react"
import { Form, data, redirect } from "react-router"
import { OnlyLogoLayout } from "~/components/layouts/only-logo/only-logo-layout"
import { Button } from "~/components/ui/button"
import { Typography } from "~/components/ui/typography"
import { sessionStorage } from "~/services/auth"
import type { Route } from "./+types/route"

export const action = () => {
  throw redirect("/auth/logout?session-expired")
}

export const loader = async ({ request }: Route.LoaderArgs) => {
  const session = await sessionStorage.getSession(request.headers.get("Cookie"))
  return data(null, {
    headers: {
      "Set-Cookie": await sessionStorage.destroySession(session),
    },
  })
}

export default function SessionExpired() {
  return (
    <OnlyLogoLayout showLanguageSwitcher>
      <Form method="post" className="flex items-center">
        <div className="flex flex-1 items-center justify-center">
          <div className="flex flex-col max-w-(--screen-2xl) items-center gap-4">
            <Clock
              className="size-20 text-primary"
              absoluteStrokeWidth
              strokeWidth={1.5}
            />
            <div className="flex flex-col gap-2 items-center">
              <Typography variant="h1" as="h1" fontWeight="semibold">
                {t`Session expired`}
              </Typography>

              <Typography variant="muted" className="text-muted-foreground">
                {t`You've been logged out due to inactivity.`}
              </Typography>
            </div>

            <Button type="submit" size="lg">
              {t`Sign in again`}
            </Button>
          </div>
        </div>
      </Form>
    </OnlyLogoLayout>
  )
}
